import { render } from "./expense.vue?vue&type=template&id=5ad6a83a"
import script from "./expense.vue?vue&type=script&lang=js"
export * from "./expense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__